export const FLAG_GETTING_PRINT_STATIONS = 'FLAG_GETTING_PRINT_STATIONS';
export const GET_PRINT_STATIONS = 'GET_PRINT_STATIONS';
export const CLEAR_PRINT_STATIONS = 'CLEAR_PRINT_STATIONS';
export const FLAG_PRINT_STATION_ACTIVITY = 'FLAG_PRINT_STATION_ACTIVITY';
export const GET_PRINT_STATION = 'GET_PRINT_STATION';
export const CLEAR_PRINT_STATION = 'CLEAR_PRINT_STATION';
